import { logClientRuntimeError } from "../../../../services/clientErrorLog";
/** Default preset label for Sales Order Details bootstrap range (last 30 days). */
export var ST_REPORTS_DEFAULT_PRESET_LABEL_KEY = "stReports_preset_last30Days";
export function todayAtMidnight() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
}
/** Midnight-normalized timestamp for calendar day comparison. */
export function normalizeStOrderDetailsDateToDay(date) {
    var normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized.getTime();
}
/** Sales Order Details ranges cannot extend beyond today. */
export function isStOrderDetailsSelectableDate(date) {
    return normalizeStOrderDetailsDateToDay(date) <= normalizeStOrderDetailsDateToDay(todayAtMidnight());
}
/** Clamps applied range ends to today (preserves label). */
export function clampStOrderDetailsDateRangeToToday(range) {
    var max = todayAtMidnight();
    var startDate = range.startDate ? new Date(range.startDate) : null;
    var endDate = range.endDate ? new Date(range.endDate) : null;
    if (startDate) {
        startDate.setHours(0, 0, 0, 0);
        if (startDate.getTime() > max.getTime()) {
            startDate = new Date(max);
        }
    }
    if (endDate) {
        endDate.setHours(0, 0, 0, 0);
        if (endDate.getTime() > max.getTime()) {
            endDate = new Date(max);
        }
    }
    if (startDate && endDate && startDate.getTime() > endDate.getTime()) {
        endDate = new Date(startDate);
    }
    return { startDate: startDate, endDate: endDate, label: range.label };
}
/** Default Sales Order Details range: last 30 days ending today. */
export function getDefaultDateRange() {
    try {
        var today = todayAtMidnight();
        var startDate = new Date(today);
        startDate.setDate(today.getDate() - 29);
        return { startDate: startDate, endDate: today, label: ST_REPORTS_DEFAULT_PRESET_LABEL_KEY };
    }
    catch (error) {
        logClientRuntimeError("getDefaultDateRange", error);
        var today = todayAtMidnight();
        return { startDate: today, endDate: today, label: undefined };
    }
}
/** API date format (`yyyy-MM-dd`). */
export function formatDateForAPI(date) {
    try {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var day = String(date.getDate()).padStart(2, "0");
        return "".concat(year, "-").concat(month, "-").concat(day);
    }
    catch (error) {
        logClientRuntimeError("formatDateForAPI", error);
        return "";
    }
}
